"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gdpr = require("./gdpr");

Object.keys(_gdpr).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _gdpr[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gdpr[key];
    }
  });
});

var _uniqueId = require("./uniqueId");

Object.keys(_uniqueId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _uniqueId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _uniqueId[key];
    }
  });
});

var _appSessionId = require("./appSessionId");

Object.keys(_appSessionId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _appSessionId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _appSessionId[key];
    }
  });
});

var _isAuthenticated = require("./isAuthenticated");

Object.keys(_isAuthenticated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isAuthenticated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isAuthenticated[key];
    }
  });
});

var _isSubscribed = require("./isSubscribed");

Object.keys(_isSubscribed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isSubscribed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isSubscribed[key];
    }
  });
});

var _isVIP = require("./isVIP");

Object.keys(_isVIP).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isVIP[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isVIP[key];
    }
  });
});

var _userCookies = require("./userCookies");

Object.keys(_userCookies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userCookies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _userCookies[key];
    }
  });
});